module.exports = __webpack_public_path__ + "media/images/tasks-icon-273eee34f03e15c790fc9364ca4ee9dd.svg";